module.exports = __webpack_public_path__ + "static/media/lc_feb.50e82795.png";